import {AbsenceType} from './types';

export const MockData: AbsenceType[] = [
  {
    id: 1,
    name: 'Vacation',
    externalId: '1000',
    iconName: 'vacation',
  },
  {
    id: 2,
    name: 'Sick',
    externalId: '1000',
    iconName: 'sick',
  },
  {
    id: 3,
    name: 'Sick child',
    externalId: '1000',
    iconName: 'sickChild',
  },
];
